import moment from "moment";

// Whole days in [startDt, endDt). Robust to the two end conventions the app
// produces: the dashboards pass moment().endOf("month"|"year") timestamps
// (…T23:59:59), while the handoff's worked examples assume an exclusive midnight
// end (…T00:00:00 of the next day). Rounding the fractional day-diff collapses
// both to the same whole-day count (June -> 30, 2026 -> 365).
export function daysBetween(startDt, endDt) {
  if (!startDt || !endDt) return 0;
  const diff = moment(endDt).diff(moment(startDt), "days", true);
  return Math.max(0, Math.round(diff));
}

// Days in the calendar month named by a "YYYY-MM" period key.
export function daysInMonth(periodKey) {
  return moment(periodKey, "YYYY-MM").daysInMonth();
}

// Days in a calendar year (handles leap years).
export function daysInYear(year) {
  return moment(`${year}-01-01`, "YYYY-MM-DD").isLeapYear() ? 366 : 365;
}

// Pro-rate a full-period revenue target to the viewed range and score
// attainment. Returns null when there is no target for this scope/range (the
// caller then keeps its existing reference UI). Revenue is "higher is better":
//   color = "green" (>=100%) | "amber" (<100%) | "neutral" (target 0 / N/A).
export default function kpiTargetProgress({ revenueTarget, actual, startDt, endDt }) {
  if (!revenueTarget || revenueTarget.fullTarget == null) return null;

  const rangeDays = daysBetween(startDt, endDt);
  const periodDays =
    revenueTarget.periodType === "year"
      ? daysInYear(Number(revenueTarget.periodKey))
      : daysInMonth(revenueTarget.periodKey);

  const displayedTarget =
    periodDays > 0 ? (revenueTarget.fullTarget * rangeDays) / periodDays : 0;

  const attainmentPct =
    displayedTarget > 0 ? Math.round((Number(actual) || 0) / displayedTarget * 100) : null;

  const color =
    attainmentPct == null ? "neutral" : attainmentPct >= 100 ? "green" : "amber";

  return { displayedTarget, attainmentPct, color };
}
